import { render, staticRenderFns } from "./TrainingInput.vue?vue&type=template&id=0fa509e8&"
import script from "./TrainingInput.vue?vue&type=script&lang=js&"
export * from "./TrainingInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "TrainingInput.vue"
export default component.exports